import React, { Component } from 'react';

import ScrollButton from '../ScrollButton';
import { activeId } from '../../actions';


import './Items.css';

const counter = 12;

class Pagination extends Component {

  activateButton = (id) => {
    return this.props.getPages(id)
  };

  render() {
    const { pages } = this.props
    return (
      <ul className="paginations">
        {pages.map(num => {
          const activeTable = this.props.activeId;
          const classId = activeTable === num ? 'paginations__button paginations__button-active' : 'paginations__button';
          return (
            <li className="paginations__item" key={num}>
            <ScrollButton scrollStepInPx="50" delayInMs="16.66">
              <button className={ classId } onClick={() => this.activateButton(num)}>
                {+num + 1}
              </button>
            </ScrollButton>
          </li>)
        })}
      </ul>
    );
  }
}

export default class Items extends Component {

  state = {
    items: this.props.activeId,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.activeId !== this.props.activeId) {
      this.setState({ items: this.props.activeId })
    }
  }


  render() {
    const { items } = this.props;
    if (!items.length) return null;

    const elements = items.map(item => {
      const { title, img, type } = item;
      return (
        <a className="items__element example-image-link" key={img} href={`img/items/${img}.jpg`} data-fancybox="example-set" data-caption={title}>
          <img className="items__image example-image" src={`img/items/small/${img}.jpg`} alt={type}/>
        </a>
      );
    });

    if (elements.length > counter) {
      const paginations = {};
      elements.forEach((e, i) => {
        if (i % 12 === 0) {
          const keyLength = Object.keys(paginations).length;
          paginations[keyLength] = elements.slice(i, (i + 12));
        }
      });
      const getPaginations = Object.keys(paginations);

      return (
        <div className="items-body">
          <div className="items">
            { paginations[this.state.items] }
          </div>
          <Pagination
            activeId={ this.props.activeId }
            pages={ getPaginations }
            getPages={(ids) => {
              this.props.dispatch(activeId(ids))
              return this.setState(({ items: ids }))
            }}
          />
        </div>
      );
    }

    return (
      <section className="items-body">
        <div className="items">
          { elements }
        </div>
        <Pagination
            activeId={ this.props.activeId }
            pages={ ['0'] }
            getPages={(ids) => {
              this.props.dispatch(activeId(ids))
              return this.setState(({ items: ids }))
            }}
          />
      </section>
    );
  }
}